var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Water",
    clipPath: "url(#clip0_8609_752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4055 8.02927C32.386 7.40044 31.1388 7.2464 29.9893 7.59269L11.3061 13.2212C10.1566 13.5675 9.20197 14.3848 8.69954 15.4721C8.19711 16.5594 8.17104 17.8211 8.64197 18.9154L17.3999 39.4284C18.5919 42.2126 21.6529 43.6392 24.5509 42.7661L35.2849 39.5324C38.1829 38.6594 39.9416 35.7632 39.4021 32.8L35.3717 10.8629C35.1549 9.67435 34.4411 8.65323 33.4217 8.0244L33.4055 8.02927Z",
    fill: "#232C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M21.6025 34.9517C20.1624 35.1456 18.8866 36.7472 18.5907 38.4085C18.7472 40.9108 20.9579 41.1372 21.9358 41.6074C22.9137 42.0777 28.9919 40.06 30.2318 39.814C31.4717 39.5679 36.4916 37.6048 37.3716 36.9573C38.2517 36.3097 37.9908 31.0344 37.3806 30.1984C36.7704 29.3624 34.369 32.8903 32.8435 32.585C31.3181 32.2798 30.7079 31.4438 28.7443 31.2705C26.7808 31.0972 26.5775 33.198 25.4393 34.1782C24.3012 35.1585 23.8976 34.6427 21.6025 34.9517Z",
    fill: "#C3F483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.4055 8.02927C32.386 7.40044 31.1388 7.2464 29.9893 7.59269L11.3061 13.2212C10.1566 13.5675 9.20197 14.3848 8.69954 15.4721C8.19711 16.5594 8.17104 17.8211 8.64197 18.9154L17.3999 39.4284C18.5919 42.2126 21.6529 43.6392 24.5509 42.7661L35.2849 39.5324C38.1829 38.6594 39.9416 35.7632 39.4021 32.8L35.3717 10.8629C35.1549 9.67435 34.4411 8.65323 33.4217 8.0244L33.4055 8.02927ZM33.7039 11.1887L37.7344 33.1259C38.1271 35.2503 36.8582 37.3102 34.7858 37.9345L24.0519 41.1682C21.9795 41.7925 19.7952 40.7553 18.954 38.7836L10.196 18.2706C9.91021 17.615 9.92714 16.8506 10.2244 16.1959C10.5378 15.5364 11.0976 15.0499 11.7938 14.8402L30.4609 9.21657C31.157 9.00684 31.8924 9.10317 32.518 9.4798C33.1436 9.85644 33.5589 10.473 33.6877 11.1936L33.7039 11.1887Z",
    fill: "#C3F483"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8609_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5809,
    height: 40.5809,
    fill: "white",
    transform: "translate(0 12.2123) rotate(-16.7653)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLeft);
export default __webpack_public_path__ + "static/media/water-left.d9c87727d339b386711008220d461ab2.svg";
export { ForwardRef as ReactComponent };